import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"

export default function BackButton({
  useAbsolute=true,
}:{ useAbsolute?: boolean}) {
  const navigate = useNavigate();

  if (useAbsolute) {
    return (
      <div className="absolute left-0 bottom-0 m-2">
        <BasicButton text={"Back"} onClick={() => navigate(-1)}/>
      </div>
    )
  }

  return (
    <BasicButton text={"Back"} onClick={() => navigate(-1)}/>
  )
}
